import { FC, ReactNode } from "react";

export const DateCell: FC<{ children?: ReactNode }> = ({ children }) => {
  return <div style={{ fontSize: 32 }}>{children}</div>;
};

export const NumberCell: FC<{ children?: ReactNode }> = ({ children }) => {
  return <div style={{ fontSize: 42 }}>{children}</div>;
};
